module.exports = __webpack_public_path__ + "static/media/careermind_logo.ddf707fc.svg";